// services/ecosystem/api.ts

import axiosClient from '@/http/axiosClient'
import { GetAllNewsTypesPayload, GetAllNewsTypesResponse, GetOneNewsTypeResponse } from '@/services/ecoType/type'

const NEWS_BASE_URL = process.env.NEXT_PUBLIC_NEWS_BASE_URL as string
const SITE_KEY = process.env.NEXT_PUBLIC_NEWS_SITE_KEY as string
const ALLNEWS_ID = process.env.NEXT_PUBLIC_ALLNEWS_ID as string
export const apiGetAllNewsTypes = (payload: GetAllNewsTypesPayload) =>
    axiosClient
        .post<GetAllNewsTypesResponse>(
            '/newstype/getAll',
            payload,
            {
                baseURL: NEWS_BASE_URL,
                withCredentials: false,
                headers: {
                    siteKey: SITE_KEY,
                },
            }
        )
        .then((res) => res.data)

export const apiGetAllNewsTypesChild = (payload: GetAllNewsTypesPayload) =>
    axiosClient
        .get<GetOneNewsTypeResponse>(
            `/newstype/${ALLNEWS_ID}`,
            {
                baseURL: NEWS_BASE_URL,
                withCredentials: false,
                headers: {
                    siteKey: SITE_KEY,
                },
                params: payload,
            }
        )
        .then((res) => res.data);
